"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _r10SourceLibrary = require("r10-source-library");

var _jsonpath = _interopRequireDefault(require("jsonpath"));

var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));

var _convertUnits = _interopRequireDefault(require("../utils/convertUnits"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Bucket = function Bucket(_ref) {
  var bucket = _ref.bucket,
      consumptionDetails = _ref.consumptionDetails,
      BucketsJsonPaths = _ref.BucketsJsonPaths,
      unitsAliases = _ref.unitsAliases;
  var key = bucket.key,
      icon = bucket.icon,
      displayUnit = bucket.displayUnit,
      usageType = bucket.usageType;
  var isActive = _jsonpath.default.value(consumptionDetails, BucketsJsonPaths.status.replace('{usageType}', usageType)) === 'active';
  if (!isActive) return null;
  var t = (0, _useTranslation.default)();

  var bucketConsumption = _jsonpath.default.value(consumptionDetails, BucketsJsonPaths.remindingValues.replace('{usageType}', usageType));

  var chartData = [_extends({}, {
    key: t('ADDON'),
    percentage: +bucketConsumption.amount === 0 ? 0 : 100,
    state: 'error'
  })];
  var isUnlimited = _jsonpath.default.value(consumptionDetails, BucketsJsonPaths.allowance.jsonPath.replace('{usageType}', usageType)) === BucketsJsonPaths.allowance.unlimitedValue;
  var usage = (0, _convertUnits.default)(bucketConsumption.amount, bucketConsumption.units, displayUnit, unitsAliases, t);
  var getUsageStatementDetails = t('usageDetails', {
    usage: usage
  });
  var remainingStatement = isUnlimited ? t('UNLIMITED') : getUsageStatementDetails;
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    noGutters: true,
    marginTop: 4
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.HorizontalBarChart, {
    dataAttributes: {
      'data-testid': "horizontal-bar-chart-" + key
    },
    icon: {
      name: icon
    },
    topText: {
      left: t(key),
      right: remainingStatement
    },
    steps: [].concat(chartData)
  })));
};

Bucket.propTypes = {
  bucket: _propTypes.default.object.isRequired,
  consumptionDetails: _propTypes.default.object.isRequired,
  BucketsJsonPaths: _propTypes.default.object.isRequired,
  unitsAliases: _propTypes.default.array
};
var _default = Bucket;
exports.default = _default;